/** Reference pad bundle controls. Commerce stays disabled until actual bundle pricing is connected. */
if (!customElements.get('bp-pad-offers')) {
  customElements.define('bp-pad-offers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.cards = [...this.querySelectorAll('[data-pad-offer]')];
      const selected = this.cards.find(card => card.querySelector('input[type=radio]').checked) || this.cards[0];
      if (selected) this.select(selected);

      this.addEventListener('change', event => {
        const card = event.target.closest('[data-pad-offer]');
        if (!card) return;
        if (event.target.type === 'radio') this.select(card);
        if (event.target.tagName === 'SELECT') this.syncFollowingOptions(card, event.target);
      }, { signal: this.controller.signal });

      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-pad-offer]');
        if (card && this.contains(card)) this.select(card);
      }, { signal: this.controller.signal });
    }

    select(card) {
      this.cards.forEach(candidate => {
        const active = candidate === card;
        candidate.classList.toggle('bp-pad-offer__bar--selected', active);
        candidate.querySelector('input[type=radio]').checked = active;
        candidate.querySelectorAll('select').forEach(select => { select.disabled = !active; });
      });
    }

    syncFollowingOptions(card, changed) {
      const selects = [...card.querySelectorAll('select')];
      const column = selects.indexOf(changed);
      // The original copies the first pad's color/size; later rows remain independently editable.
      if (column < 0 || column > 1) return;
      selects.forEach((select, index) => {
        if (index > column && index % 2 === column) select.value = changed.value;
      });
    }

    disconnectedCallback() { this.controller?.abort(); }
  });
}
